module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "vbl-checkbox",
    class: [{
      'is-disabled': _vm.disabled
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataValue),
      expression: "dataValue"
    }],
    attrs: {
      "type": "checkbox",
      "true-value": _vm.trueValue,
      "false-value": _vm.falseValue,
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.nativeValue,
      "checked": Array.isArray(_vm.dataValue) ? _vm._i(_vm.dataValue, _vm.nativeValue) > -1 : _vm._q(_vm.dataValue, _vm.trueValue)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.dataValue,
          $$el = $event.target,
          $$c = $$el.checked ? (_vm.trueValue) : (_vm.falseValue);
        if (Array.isArray($$a)) {
          var $$v = _vm.nativeValue,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dataValue = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.dataValue = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dataValue = $$c
        }
      }, function($event) {
        _vm.$emit('change', $event)
      }]
    }
  }), _c('span', {
    staticClass: "check"
  }), _c('span', {
    staticClass: "control-label"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ec5812a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/vblCheckbox/src/vblCheckbox.vue
// module id = 297
// module chunks = 0